import "./App.css";
import HeaderHero from "./components/HeaderHero";
import VisitingCardSection from "./components/VisitingCardSection";
import FeaturedServicesSection from "./components/FeaturedServicesSection";
import ServicesSection from "./components/ServicesSection";
import CleaningSection from "./components/CleaningSection";
import WhySection from "./components/WhySection";
import LocalSeoSection from "./components/LocalSeoSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ReelsSection from "./components/ReelsSection";
import GoogleReviewSection from "./components/GoogleReviewSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";
import ChatbotWidget from "./components/ChatbotWidget";
import CookieConsentBanner from "./components/CookieConsentBanner";

function App() {
  return (
    <div className="app">
      <HeaderHero />
      <VisitingCardSection />
      <FeaturedServicesSection />
      <ServicesSection />
      <CleaningSection />
      <WhySection />
      <LocalSeoSection />
      <TestimonialsSection />
      <ReelsSection />
      <GoogleReviewSection />
      <ContactSection />
      <FooterSection />
      <ChatbotWidget />
      <CookieConsentBanner />
    </div>
  );
}

export default App;
